import { Calendar, Check, FileText, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { COLOR_AZUL_MAIN } from "../utils/const/colors-const";

const normalizarEstado = (raw) => {
    if (typeof raw !== "string") return null;
    const v = raw.trim().toLowerCase();
    if (v === "aprobado") return "aprobado";
    if (v === "rechazado") return "rechazado";
    return null;
};

export default function CardSolicitudProducto({
    item,
    onClick,
    onAccept,
    onReject,
    selected = false,
}) {
    const { t } = useTranslation();

    const handleClick = () => {
        if (typeof onClick === "function") {
            onClick(item);
        }
    };

    const estado = normalizarEstado(item?.Estado);
    const motivo = typeof item?.Motivo === "string" ? item.Motivo.trim() : "";

    return (
        <div
            role="button"
            tabIndex={0}
            onClick={handleClick}
            onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") handleClick();
            }}
            className={`w-full text-left bg-white border rounded-lg p-3 shadow-sm transition-all hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-1 ${selected
                ? "border-blue-500 ring-2 ring-blue-200"
                : "border-gray-200 hover:border-gray-300"
                }`}
        >
            <div
                className="h-1 w-10 rounded-full mb-3"
                style={{ backgroundColor: COLOR_AZUL_MAIN }}
            />
            <div className="flex items-start gap-2 min-w-0">
                <FileText className="h-4 w-4 shrink-0 mt-0.5 text-gray-500" />
                <p className="text-sm font-semibold text-gray-900 leading-snug break-words">
                    {item?.descripcion ?? "—"}
                </p>
            </div>
            <div className="flex items-center gap-2 mt-2 min-w-0">
                <Calendar className="h-3.5 w-3.5 shrink-0 text-gray-400" />
                <p className="text-xs text-gray-500 truncate">
                    {item?.fechaProceso ?? "—"}
                </p>
            </div>

            {estado === "aprobado" && (
                <div className="mt-3 pt-2 border-t border-gray-100">
                    <div className="inline-flex items-center gap-1.5 px-2 py-1 rounded-full bg-green-50 border border-green-200 text-green-700 text-xs font-medium">
                        <Check className="h-3.5 w-3.5" />
                        {t("label_aprobado") || "Aprobado"}
                    </div>
                    {motivo.length > 0 && (
                        <p className="text-xs text-gray-500 mt-2 break-words">
                            <span className="font-medium text-gray-600">
                                {t("label_motivo") || "Motivo"}:
                            </span>{" "}
                            {motivo}
                        </p>
                    )}
                </div>
            )}

            {estado === "rechazado" && (
                <div className="mt-3 pt-2 border-t border-gray-100">
                    <div className="inline-flex items-center gap-1.5 px-2 py-1 rounded-full bg-red-50 border border-red-200 text-red-600 text-xs font-medium">
                        <X className="h-3.5 w-3.5" />
                        {t("label_rechazado") || "Rechazado"}
                    </div>
                    {motivo.length > 0 && (
                        <p className="text-xs text-gray-500 mt-2 break-words">
                            <span className="font-medium text-gray-600">
                                {t("label_motivo") || "Motivo"}:
                            </span>{" "}
                            {motivo}
                        </p>
                    )}
                </div>
            )}

            {estado == null && (
                <div className="flex justify-end gap-2 mt-3 pt-2 border-t border-gray-100">
                    <button
                        type="button"
                        className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-red-50 border border-red-200 text-red-600 hover:bg-red-100"
                        onClick={(event) => {
                            event.stopPropagation();
                            onReject?.(item);
                        }}
                    >
                        <X className="h-4 w-4" />
                    </button>
                    <button
                        type="button"
                        className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-green-50 border border-green-200 text-green-700 hover:bg-green-100"
                        onClick={(event) => {
                            event.stopPropagation();
                            onAccept?.(item);
                        }}
                    >
                        <Check className="h-4 w-4" />
                    </button>
                </div>
            )}
        </div>
    );
}
